// Local storage cache for NTB articles
const CACHE_PREFIX = 'ntb_cache_';
const CACHE_DURATION = 60 * 60 * 1000; // 1 hour

export interface CachedArticle {
  data: any;
  timestamp: number;
  expiresAt: number;
}

export class NTBCache {
  static get(key: string): any | null {
    try {
      const cached = localStorage.getItem(`${CACHE_PREFIX}${key}`);
      if (!cached) return null;

      const parsedCache: CachedArticle = JSON.parse(cached);
      
      // Check if cache is expired
      if (Date.now() > parsedCache.expiresAt) {
        this.remove(key);
        return null;
      }

      console.log('Cache hit for NTB key:', key);
      return parsedCache.data;
    } catch (error) {
      console.warn('Error reading from NTB cache:', error);
      return null;
    }
  }

  static set(key: string, data: any): void {
    try {
      const cached: CachedArticle = {
        data,
        timestamp: Date.now(),
        expiresAt: Date.now() + CACHE_DURATION
      };

      localStorage.setItem(`${CACHE_PREFIX}${key}`, JSON.stringify(cached));
      console.log('Cached NTB data for key:', key);
    } catch (error) {
      console.warn('Error writing to NTB cache:', error);
    }
  }

  static remove(key: string): void {
    try {
      localStorage.removeItem(`${CACHE_PREFIX}${key}`);
    } catch (error) {
      console.warn('Error removing from NTB cache:', error);
    }
  }

  static clear(): void {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(CACHE_PREFIX)) {
          localStorage.removeItem(key);
        }
      });
      console.log('Cleared all NTB cache entries');
    } catch (error) {
      console.warn('Error clearing NTB cache:', error);
    }
  }

  static getStats(): { totalEntries: number; totalSize: number } {
    try {
      const keys = Object.keys(localStorage);
      const ntbKeys = keys.filter(key => key.startsWith(CACHE_PREFIX));
      
      let totalSize = 0;
      ntbKeys.forEach(key => {
        const value = localStorage.getItem(key);
        if (value) {
          totalSize += value.length;
        }
      });

      return {
        totalEntries: ntbKeys.length,
        totalSize
      };
    } catch (error) {
      console.warn('Error getting NTB cache stats:', error);
      return { totalEntries: 0, totalSize: 0 };
    }
  }
}